<template>
  <modal name="modal-add-client" height="auto" :width="560"
    :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>ADD {{ type.toUpperCase() }}</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <template v-if="postData">
      <form method="post" action="" ref="form" @submit.prevent="doCreate">
        <div class="row">
          <div class="form-group col">
            <label for="name">Company Name <span class="text-danger">*</span></label>
            <input type="text" name="name" id="name" ref="inputName"
                   :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                   v-validate.disable="{ required: true }"
                   v-model="postData.name">
            <div class="invalid-feedback">{{ errors.first('name') }}</div>
          </div>
          <div class="form-group col">
            <label for="code">Code (4 characters)</label>
            <input type="text" class="form-control" id="code" v-model="postData.code">
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <label for="email">Contact Email <span class="text-danger">*</span></label>
            <input type="text" name="email" id="email"
                   :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                   v-validate.disable="{ required: true }"
                   v-model="postData.email">
            <div class="invalid-feedback">{{ errors.first('email') }}</div>
          </div>
          <div class="form-group col">
            <label for="phone">Contact Phone</label>
            <input type="text" class="form-control" id="phone" v-model="postData.phone">
          </div>
        </div>
        <div class="form-group">
          <label>Address 1</label>
          <input type="text" class="form-control" v-model="postData.address_1" placeholder="Address line 1...">
        </div>
        <div class="form-group">
          <label>Address 2</label>
          <input type="text" class="form-control" v-model="postData.address_2" placeholder="Address line 2...">
        </div>
        <div class="form-group">
          <label>STATE</label>
          <v-select v-model="postData.state" :options="allStates" class="form-control" :reduce="item => item.code"
                    label="name" :searchable="true" :placeholder="'- Select state'"></v-select>
          <div v-if="postData.state == 'Other'">
            <br/>
            <input type="text" class="form-control" placeholder="Please enter the state"  v-model="postData.other_state">
          </div>
        </div>
        <div class="row ">
          <div class="form-group col">
            <label>Suburb</label>
            <input type="text" class="form-control" v-model="postData.suburb">
          </div>
          <div class="form-group col">
            <label>Postcode</label>
            <input type="text" class="form-control" v-model="postData.postcode">
          </div>
        </div>
        <!-- <div class="custom-control custom-checkbox mb-2">
          <input type="checkbox" class="custom-control-input" id="create_account" v-model="postData.create_account">
          <label class="custom-control-label" for="create_account">Create client account</label>
        </div> -->

        <div class="pt-2 btns btns-2">
          <beat-loader v-if="state == 'saving'"></beat-loader>
          <template v-else>
            <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
            <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
          </template>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader'

export default {
  components: {
    BeatLoader,
  },
  data () {
    return {
      state: '',
      postData: false,
    }
  },
  props: ['value', 'type'],
  computed: mapState({
    allStates: state => state.option.stateWithOtherOpts
  }),
  watch: {
    value ( newVal ) {
      let self = this;
      if ( newVal ) {
        self.$modal.show('modal-add-client', {});
        setTimeout(() => {
          self.$refs.inputName.focus();
        }, 200);
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.resetForm();
    },
    resetForm () {
      let self = this;
      self.postData = {
        name: '',
        code: '',
        email: '',
        phone: '',
        address_1: '',
        address_2: '',
        suburb: '',
        state: '',
        other_state: '',
        postcode: '',
        create_account: false,
        is_supplier: 0
      };
    },
    closeModal () {
      this.$modal.hide('modal-add-client');
    },
    doCreate ( ) {
      let self = this;
      if (self.state == 'saving') {
        return;
      }

      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            self.state = 'saving';
            if (typeof self.type != "undefined" && self.type == 'supplier') {
              self.postData.is_supplier = 1;
            }
            self.$store.dispatch('ADD_CLIENT_SUPPLIER', self.postData)
              .then(client => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: window.capitalize(self.type) + ' "<strong>' + client.name + '</strong>" added successfully.'
                });
                self.resetForm();
                self.$emit('added', client);
                self.closeModal();
              })
              .catch((error) => {
                window.console.log(error);
                self.state = '';
              });
          }
        });
    }
  }
}
</script>
